import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  mode: 'light' | 'dark'
  direction: 'rtl' | 'ltr'
  accentColor: string
  setMode: (mode: 'light' | 'dark') => void
  setDirection: (direction: 'rtl' | 'ltr') => void
  setAccentColor: (color: string) => void
  toggleMode: () => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'light',
      direction: 'rtl',
      accentColor: '#22c55e', // green-500
      setMode: (mode) => set({ mode }),
      setDirection: (direction) => set({ direction }),
      setAccentColor: (color) => set({ accentColor: color }),
      toggleMode: () =>
        set((state) => ({
          mode: state.mode === 'light' ? 'dark' : 'light',
        })),
    }),
    {
      name: 'sakeena-theme',
    }
  )
)


